module.exports = __webpack_public_path__ + "media/partners/clorox-511e8a2e.svg";